export default function isWhite(hex) {
  hex = hex
    .replace('#', '')
    .toLowerCase()

  // Convert 3-digit hex to 6-digit hex if needed
  if (hex.length === 3) {
    hex = hex.split('').map(x => x + x).join('')
  }

  return hex === 'ffffff'
}
